import { render, staticRenderFns } from "./AccessMoreStrategiesDialog.vue?vue&type=template&id=cb0cadbe&scoped=true&"
import script from "./AccessMoreStrategiesDialog.vue?vue&type=script&lang=ts&"
export * from "./AccessMoreStrategiesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AccessMoreStrategiesDialog.vue?vue&type=style&index=0&id=cb0cadbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0cadbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow})
